const currencies = [
  // {
  //   value: 'USD',
  //   label: '$',
  // },
  {
    value: 'EUR',
    label: '€',
  },
  // {
  //   value: 'BTC',
  //   label: '฿',
  // },
  // {
  //   value: 'JPY',
  //   label: '¥',
  // },
];

export default currencies;
